module.exports = __webpack_public_path__ + "static/img/wx.64e315da.png";